import React, { useState } from 'react';
import './SideMenu.css';
import {
    Link,
    useLocation
} from 'react-router-dom';

import {MenuContext} from './SideMenuContext';

const mainMenuItemsDef = [
    {
        menuLink:'#home',
        name:"Home",
        key:"home",
        isCollapsed:true
    },
    {
        menuLink:'#features',
        name:"Features",
        key:"why-odanow",
        isCollapsed:true
    },
    {
        menuLink:'#pricing-plans',
        name:"Pricing",
        key:"our-story",
        isCollapsed:true
    }/* ,     
    {
        menuLink:'/contact-us',
        name:"Contact Us",
        key:"contact-us",
        isCollapsed:true
    } */
]

const subMenuItems = [];


const SideMenuHorizontal = (props) =>
{
    //const user = useSelector(state => state.user);
    //const dispatch = useDispatch();
    const location = useLocation();

    const [mainMenuItems, setMainMenuItems] = useState([...mainMenuItemsDef])

    const [menuSearchString, setMenuSearchString] = useState("")
    
    const filterMenuItems = (menuItems) => {
        if(menuSearchString && menuSearchString != "")
        {
            let filteredMenuItems = menuItems.filter( mi => {
                if(mi.name.toLowerCase().match(menuSearchString.toLowerCase()))
                {
                    return true;
                }
                else
                {
                    // Search the submenus
                    let foundSubMenuItems = subMenuItems.filter(sm => sm.parentKey === mi.key && sm.menuCaption.toLowerCase().match(menuSearchString.toLowerCase()))

                    if(foundSubMenuItems && foundSubMenuItems.length>0)
                    {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
            })

            return filteredMenuItems.map(fm => {return {...fm, isCollapsed:false}});
        }
        else
        {
            return menuItems
        }
    }
    
    const collapseMenuItem = (key) =>{
        let selectedMenuItem = mainMenuItems.find(mi => mi.key === key);

        if(selectedMenuItem)
        {
            selectedMenuItem.isCollapsed = !selectedMenuItem.isCollapsed;

            setMainMenuItems([...mainMenuItems.map(
                (m, i) => m.key === selectedMenuItem.key ? selectedMenuItem
                                        : m)])
        }
    }

    const isCurrentLink = (menuItem) => {
        // Search the submenus
        let foundSubMenuItems = subMenuItems.filter(sm => sm.menuLink === location.pathname && menuItem.key === sm.parentKey)

        if(foundSubMenuItems && foundSubMenuItems.length>0)
        {
            return true
        }
        else
        {
            return false;
        }
    }

    return (
        <MenuContext.Consumer>
        {({isOpen, setIsOpen}) => (
        <>
        
        <div className='side-menu-horizontal-wrap'>

        <div className='side-menu-horizontal-row'>
        {/*<div style={{display:'flex', flexDirection:'column', padding:8, paddingBottom:2, margin:'0px 0px', alignItems:'center', justifyContent:'center'}}>
            <input placeholder="Search" value={menuSearchString} onChange={(e)=>setMenuSearchString(e.target.value)} style={{boxSizing:'border-box', boxShadow:'0px 0px 2px rgba(10,10,10,0.2)', background:"#eeeeee", padding:'2px 10px', height:30, border:'1px solid #CCCCCC', width:'100%', borderRadius:5}}/>
        </div>*/}
        {
            filterMenuItems(mainMenuItems).map(ss => <div key={ss.key} className='side-menu-horizontal-item'>
                {ss.menuLink ? 
                ss.isExternal ?  
                <a href={ss.menuLink} className={`side-menu-horizontal-category-label ${ss.menuLink === location.pathname || isCurrentLink(ss)|| location.hash.includes(ss.menuLink)? 'side-menu-horizontal-category-label-active' : 'side-menu-horizontal-category-label-inactive'}`}><span className={`side-menu-horizontal-category-label`}>{ss.name}</span></a>
                
                :
                <Link to={ss.menuLink} className={`side-menu-horizontal-category-label ${ss.menuLink === location.pathname || isCurrentLink(ss) || location.hash.includes(ss.menuLink)? 'side-menu-horizontal-category-label-active' : 'side-menu-horizontal-category-label-inactive'}`}><span className={`side-menu-horizontal-category-label`}>{ss.name}</span></Link> :
                <div className={'side-menu-horizontal-category-label-inactive side-menu-horizontal-category-label'}>{ss.name}</div>}
                <ul className={'side-menu-links-container'}>
                {!ss.isCollapsed && subMenuItems.filter(s => s.parentKey === ss.key).map(sm => <li key={sm.menuLink} className={'side-menu-links-item'}><div>
                
                    <Link className={'side-menu-container-link'} style={{fontWeight:`${sm.menuLink === location.pathname ? 'bold':'normal' }`}} to={sm.menuLink}>{sm.menuCaption}</Link>
                    </div></li>)}
                </ul>
                </div>)
        }
        {/*user? <div style={{cursor:'pointer'}} onClick={(e)=>{e.preventDefault(); signOutUser(dispatch)}} className={'side-menu-category-label-inactive side-menu-category-label'}>Logout</div>:<Link className={'side-menu-category-label'} to={'/login'}>Login</Link>*/}
        </div>
        </div></>)}
        </MenuContext.Consumer>)
}

export default SideMenuHorizontal;